// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2Frh9","title":"ClientReferral_title__16ubg","itemText":"ClientReferral_itemText__1GDBB"};